import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { Slot } from '@radix-ui/react-slot'

type Variant =
  | 'primary'
  | 'primary-outline'
  | 'secondary'
  | 'light-outline'
  | 'fill-charcoal'
  | 'outline'
type Size = 'medium' | 'large'

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant
  size?: Size
  fill?: boolean
  asChild?: boolean
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = '', fill = false, asChild = false, className = '', ...rest },
  ref,
) {
  const Comp = asChild ? Slot : 'button'
  const cls = [
    'button',
    `button--${variant}`,
    `button--${size}`,
    fill ? 'button--fill' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')
  return <Comp ref={ref as never} className={cls} {...rest} />
})
